import axios from './base'
const url = `/activity`

// ================= 活动管理（后端 ActivityService，tb_activity + mg_activity_flows，/activity*） =================

// 活动列表（分页 + 筛选：keyword 名称模糊 / category 字典值精确 / status 精确）
// 返回 data:{list,total,page,page_size}；行含 flow_days（流程天数，流程列显示用），不含 intro/flows
export function getActivityList(params = {}) {
  return axios.request({
    url: `${url}`,
    method: "get",
    params,
  })
}

// 活动详情：列表字段 + intro（富文本）+ flows（[{flow_date, nodes:[{start_time,end_time,title,description,extra}]}]）
export function getActivityDetail(id, params = {}) {
  return axios.request({
    url: `${url}/${id}`,
    method: "get",
    params,
  })
}

// 新增活动（status: 0 存草稿 / 1 发布；flows 整体保存）
export function createActivity(data = {}) {
  return axios.request({
    url: `${url}`,
    method: "post",
    data,
  })
}

// 编辑活动（flows 未传不动既有流程，传了则整体覆盖）
export function updateActivity(id, data = {}) {
  return axios.request({
    url: `${url}/${id}`,
    method: "put",
    data,
  })
}

// 删除活动（软删，流程一并打删除标记）
export function deleteActivity(id, data = {}) {
  return axios.request({
    url: `${url}/${id}`,
    method: "delete",
    data,
  })
}

// 更新活动状态（body: {status}；1 报名中 / 2 进行中 / 3 已结束，不支持 0 草稿）
export function updateActivityStatus(id, data = {}) {
  return axios.request({
    url: `${url}/${id}/status`,
    method: "put",
    data,
  })
}
